export default "__VITE_ASSET__BxJb_qNk__"